import { StoryblokComponent } from '@storyblok/react';
import clsx from 'clsx';

import { renderRichText } from '@edelman/storyblok-ui/src/components/blocks/SBRichText';
import { componentContainerProps } from '@edelman/storyblok-ui/src/utils';
import { ComponentContainer, RichText, Typography, ChildContainer, Grid } from '@edelman/ui';
import { sbEditable, SBSectionProps } from '@edelman/utils';

export const DefaultVariant = ({ blok, componentClassName, componentIndex }: SBSectionProps) => {
  // Content bloks
  const { title, richText, content } = blok;
  // Variant settings
  const variant = {
    componentClassName,
    contentWidth: 'default',
    padding: true,
    minHeight: 'auto',
    verticalPosition: 'top',
    animation: 'fadein',
  };

  // Variant styles
  const variantStyles = clsx('');
  const contentSyles = clsx('');
  const titleStyles = clsx('!mb-0');

  // Content
  const contentRichText = renderRichText(richText);

  return (
    <ComponentContainer
      {...componentContainerProps({
        blok,
        variant,
        componentIndex,
        className: variantStyles,
      })}
      {...sbEditable(blok)}
    >
      <ChildContainer layout="cols" className={contentSyles}>
        {title && (
          <Typography variant="h2" className={titleStyles}>
            {title}
          </Typography>
        )}
        {contentRichText !== false && <RichText>{contentRichText}</RichText>}
        {/* eslint-disable-next-line no-magic-numbers */}
        {content?.length > 0 && (
          <Grid>
            {content?.map(nestedBlok => (
              <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
            ))}
          </Grid>
        )}
      </ChildContainer>
    </ComponentContainer>
  );
};
